import { Injectable, inject } from '@angular/core';
import { Auth, signInWithEmailAndPassword, signOut, createUserWithEmailAndPassword, sendPasswordResetEmail, confirmPasswordReset, updateProfile, User } from '@angular/fire/auth';
import { from } from 'rxjs';

import { getUserRole } from 'src/app/utils/util';

export interface ISignInCredentials {
  email: string;
  password: string;
}

export interface ICreateCredentials {
  email: string;
  password: string;
  displayName: string;
}

export interface IPasswordReset {
  code: string;
  newPassword: string;
}

@Injectable({ providedIn: 'root' })
export class AuthService {
  private auth = inject(Auth);

  signIn(credentials: ISignInCredentials) {
    return signInWithEmailAndPassword(this.auth, credentials.email, credentials.password)
      .then(({ user }) => {
        return user;
      });
  }

  signOut() {
    return from(signOut(this.auth));
  }

  register(credentials: ICreateCredentials) {
    return createUserWithEmailAndPassword(this.auth, credentials.email, credentials.password)
      .then(async ({ user }) => {
        await updateProfile(user, {
          displayName: credentials.displayName,
        });
        return user;
      });
  }

  sendPasswordEmail(email: string) {
    return sendPasswordResetEmail(this.auth, email).then(() => {
      return true;
    });
  }

  resetPassword(credentials: IPasswordReset) {
    return confirmPasswordReset(this.auth, credentials.code, credentials.newPassword)
      .then((data) => {
        return data;
      });
  }

  async getUser() {
    const u = this.auth.currentUser;
    return { ...u, role: getUserRole() };
  }
}
